<template>
    <div class="feed-media"></div>
</template>
<script>
export default {
    name: 'article-element',
    props: {
        feed: {
            type: Object,
            required: true
        },
    }
}
</script>